<template>
    <div class="advert-top" v-if="message1">
        <div class="ico-horn">
            <!-- 喇叭图标 -->
            <img src="../../assets/common/laba.png" alt="">
        </div>
        <!-- 滚动文字区域 -->
        <div class="marquee-wrap">
            <ul class="marquee-box" id="marquee-box">
                <!-- 循环3次为了无缝衔接， 给第一个设置Id 方便计算文字宽度 -->
                <li class="marquee-list" v-for="i in 3" v-html="message1" :id=" i===1 ? 'marquee': ''"></li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {
    name: "notice-bar",
    data () {
      return {
        message1: ''
      }
    },
    props: {
      message: {
        type: String,
        default: ''
      }
    },
    watch: {
      message () {
        // 延时滚动
        this.message1 = this.message
        setTimeout(() => {
          this.runMarquee()
        }, 1000)
      }
    },
    mounted () {
    },
    methods: {
      runMarquee() {
        // 获取文字 计算后宽度
        let width = document.getElementById('marquee').getBoundingClientRect().width,
          marquee = document.getElementById('marquee-box'),
          disx = 0; // 位移距离
        //设置位移
        setInterval(() => {
          disx--; // disx-=1; 滚动步长
          if (-disx >= width) {
            disx = 10; // 如果位移超过文字宽度，则回到起点  marquee-list的margin值
          }
          // marquee.style.transform = 'translateX(' + disx + 'px)'
          marquee.style.left = disx + 'px'
        }, 30) //滚动速度
      }
    }
  }
</script>

<style lang="scss" scoped>
    .advert-top{
        position: relative;
        display: flex;
        width: 100%;
        height: 26px;
        background-color: #feeec4;
        color: #98713d;
        font-size: 13px;
        align-items: center;
    }
    .ico-horn{
        display: flex;
        width: 44px;
        height: 44px;
        justify-content: center;
        align-items: center
    }
    .ico-horn>img{
        width: 16px;
        height: 16px
    }
    /* 以下代码与滚动相关 */
    .marquee-wrap{
        position: relative;
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 100%
    }
    .marquee-box{
        position: absolute;
        top: 50%;
        display: flex;
        white-space: nowrap;
        transform: translateY(-50%);
    }
    .marquee-list{
        margin-right: 10px
    }
    .marquee-list span{
        padding:0 .04rem;
        color:#ffe17b;
        font-weight:700;
    }
</style>


// WEBPACK FOOTER //
// src/components/public/noticeBar.vue